import { AlertTriangle } from "lucide-react";
import { AppHeader } from "@/components/sartn/AppHeader";
import { chooseLocalizedText } from "@/lib/localizedText";
import { useLanguageStore } from "@/stores/languageStore";

export default function NotFoundPage() {
  const language = useLanguageStore((state) => state.language);

  return (
    <div className="flex flex-1 flex-col bg-[var(--color-bg)]">
      <AppHeader title="Page not found / ገጹ አልተገኘም" onBack={() => (window.location.hash = "/")} />
      <main className="flex flex-1 flex-col items-center justify-center px-6 pb-24 text-center">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50">
          <AlertTriangle className="h-7 w-7 text-amber-600" />
        </div>
        <h1 className="font-headline text-xl font-bold text-[var(--color-text)]">
          {chooseLocalizedText("This page is not available / ይህ ገጽ አይገኝም", language)}
        </h1>
        <p className="mt-2 text-sm text-[var(--color-text-muted)]">
          {chooseLocalizedText(
            "The link may be old or the feature is not shipped yet. / ሊንኩ አሮጌ ሊሆን ይችላል ወይም ባህሪው ገና አልተለቀቀም።",
            language,
          )}
        </p>
        <button
          type="button"
          onClick={() => (window.location.hash = "/")}
          className="mt-5 rounded-xl bg-[var(--color-primary)] px-4 py-2 text-sm font-semibold text-white"
        >
          {chooseLocalizedText("Go home / ወደ መነሻ", language)}
        </button>
      </main>
    </div>
  );
}
